import { getFunctions, httpsCallable } from "firebase/functions";

/**
 * Portal forgot-password callable (CL-388F). Resend-backed; enumeration-safe response.
 * @param {{ email: string }} payload
 */
export async function callRequestPasswordReset({ email }) {
  const functions = getFunctions(undefined, "us-central1");
  const fn = httpsCallable(functions, "requestPasswordReset");
  const result = await fn({ email: String(email ?? "").trim() });
  return result.data;
}
